<template>
  <base-card title="Detail Penjualan">
    <div class="grid grid-cols-1 gap-y-3 gap-x-4 sm:grid-cols-6">
      <div class="sm:col-span-3">
        <base-input
          label="No Faktur"
          placeholder="AB.001-001"
          inset
          fullwidth
          disabled
        >
          <button class="text-sm text-gray-900 inline-flex items-center gap-1" @click="detailModalVisible = true">
            {{ orderCode }}

            <Icon icon="heroicons:arrow-top-right-on-square" />
          </button>
        </base-input>
      </div>
      <div class="sm:col-span-3">
        <base-input
          label="Pembayaran"
          placeholder=""
          inset
          fullwidth
          disabled
          :value="order.data.attributes.paid_by ?? '-'"
        />
      </div>
      <div :class="[toStockist && balanceVisible ? 'sm:col-span-2' : 'sm:col-span-3']">
        <base-input
          :label="`Kode ${destinationOfficeTypeLabel}`"
          placeholder="N-12"
          inset
          fullwidth
          disabled
          :value="orderDestinationOffice ? destinationOfficeCode : null"
        />
      </div>
      <div :class="[toStockist && balanceVisible ? 'sm:col-span-2' : 'sm:col-span-3']">
        <base-input
          label="Nama Pemilik"
          placeholder="Dion"
          inset
          fullwidth
          disabled
          :value="
            orderDestinationOffice
              ? orderDestinationOffice.attributes.name
              : null
          "
        />
      </div>
      <div
        v-if="toStockist && balanceVisible"
        class="sm:col-span-2"
      >
        <base-input
          label="Saldo Stockist"
          placeholder="0"
          inset
          fullwidth
          disabled
          :value="orderDestinationOffice.attributes.order_balance_available | toCurrency"
        />
      </div>
      <div class="sm:col-span-3">
        <base-input
          label="Kode Gudang"
          placeholder="GD.AB-001"
          inset
          fullwidth
          disabled
          :value="order.data.attributes.origin_warehouse_code"
        />
      </div>
      <div class="sm:col-span-3">
        <base-input
          label="Wilayah Harga"
          placeholder="0"
          inset
          fullwidth
          disabled
          :value="order.data.attributes.area_code"
        />
      </div>
      <div class="sm:col-span-3">
        <base-input
          label="Total Penjualan"
          placeholder="100.000"
          inset
          fullwidth
          disabled
          :value="order.data.attributes.grand_total_price | toCurrency"
        />
      </div>
      <div class="sm:col-span-3">
        <base-input
          label="Metode Pengiriman"
          placeholder="Diambil"
          inset
          fullwidth
          disabled
          :value="
            order.data.attributes.order_shipment === 'delivery'
              ? 'Dikirim'
              : 'Diambil'
          "
        />
      </div>
      <div class="col-span-full">
        <base-input
          label="Catatan"
          placeholder="Catatan"
          inset
          fullwidth
          disabled
          :value="
            order.data.attributes.notes || '-'
          "
        />
      </div>
    </div>

    <view-order-modal
      :with-payment="false"
      :order-detail-columns="['code', 'qty', 'price', 'total_price', 'packed_qty', 'unpacked_qty']"
      :columns="[
        'code',
        'warehouse',
        'office',
        'date',
        'user',
        'area',
        'shipment_type',
        'address',
      ]"
      readonly
      label="Penjualan"
      with-bonus
      :visible="detailModalVisible"
      :order-id="order.data.id"
      @close="detailModalVisible = false"
    />
  </base-card>
</template>

<script>
import ViewOrderModal from '../order/view-order-modal.vue';

export default {
  components: { ViewOrderModal },
  props: {
    order: Object,
  },
  data() {
    return {
      detailModalVisible: false
    }
  },
  computed: {
    orderCode() {
      if (!this.order.data.attributes.reference_code) {
        return this.order.data.attributes.origin_code;
      }

      return `${this.order.data.attributes.origin_code} | ${this.order.data.attributes.reference_code}`;
    },
    orderOriginOffice() {
      return this.getSingleIncluded(
        this.order,
        this.order.data.relationships['origin-office'].data.id
      );
    },
    orderDestinationOffice() {
      return this.getSingleIncluded(
        this.order,
        this.order.data.relationships['destination-office'].data.id
      );
    },
    destinationOfficeTypeLabel() {
      return this.orderDestinationOffice
        ? this.orderDestinationOffice.attributes.office_type
            .split('_')
            .map((t) => t.charAt(0).toUpperCase() + t.slice(1))
            .join(' ')
        : '';
    },
    destinationOfficeCode() {
      if (this.orderDestinationOffice.attributes.office_type !== 'member') {
        return this.orderDestinationOffice.attributes.code;
      }

      return this.orderDestinationOffice.attributes.is_active
        ? this.orderDestinationOffice.attributes.code
        : this.orderDestinationOffice.attributes.temp_code;
    },
    toStockist() {
      return this.orderDestinationOffice && this.orderDestinationOffice.attributes.office_type === 'stockist'
    },
    balanceVisible() {
      return this.orderOriginOffice.attributes.office_type === 'pusat' || this.orderOriginOffice.attributes.office_type === 'kantor_pelayanan'
    }
  },
};
</script>
